import conf from 'src/conf/conf';
import { jwtDecode } from 'jwt-decode';
export function readOidcUserFromLocalStorage() {
    const user = localStorage.getItem(`oidc.user:${conf.identityPath}:${conf.clientId}`);
    return user ? JSON.parse(user) : null;
}
export function getParsedAccessToken() {
    const user = readOidcUserFromLocalStorage();
    const accessToken = user?.access_token;
    if (!accessToken)
        return null;
    return jwtDecode(accessToken);
}
